export default function ContractHorizontalIcon(props: { fill?: string }) {
  const color = props.fill ?? 'white';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      role="img"
      viewBox="0 0 20 20"
    >
      {/* central vertical bar */}
      <line
        x1="10"
        y1="3"
        x2="10"
        y2="17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* left arrow pointing right (inwards) */}
      <line
        x1="2.5"
        y1="10"
        x2="8"
        y2="10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <polyline
        points="4.5 7 7.5 10 4.5 13"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* right arrow pointing left (inwards) */}
      <line
        x1="17.5"
        y1="10"
        x2="12"
        y2="10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <polyline
        points="15.5 7 12.5 10 15.5 13"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
